(function () {
  function initClinicalGallery(root) {
    var gate = root.querySelector('[data-ebw-clinical-gate]');
    var gallery = root.querySelector('[data-ebw-clinical-gallery]');
    var button = root.querySelector('[data-ebw-clinical-accept]');
    if (!gate || !gallery || !button || gate.dataset.ready === 'true') return;
    gate.dataset.ready = 'true';

    // Share the Results page's session-level clinical-image approval.
    var storageKey = 'evebraResultsClinicalImagesViewed';
    function reveal(moveFocus) {
      gallery.querySelectorAll('img[data-src]').forEach(function (image) {
        image.src = image.getAttribute('data-src');
        image.removeAttribute('data-src');
      });
      gallery.hidden = false;
      gate.hidden = true;
      if (moveFocus) gallery.focus({ preventScroll: true });
    }

    try {
      if (window.sessionStorage.getItem(storageKey) === 'true') {
        reveal();
        return;
      }
    } catch (error) {
      // Approval still works if session storage is unavailable.
    }

    button.addEventListener('click', function () {
      try {
        window.sessionStorage.setItem(storageKey, 'true');
      } catch (error) {
        // Reveal for this page view even if the choice cannot be stored.
      }
      reveal(true);
    });
  }

  function init() {
    document.querySelectorAll('.ebw').forEach(initClinicalGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
}());
